import { useState, useEffect, useRef } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import LandingNav from "../shared/LandingNav";
import LandingFooter from "../shared/LandingFooter";
import { ACCENT, PAGINA_PUBLICA_STYLE } from "../shared/landingTheme";
import { VideoDestaque, CardGif, TituloSecao, VitrineEstilos } from "../shared/VitrineProduto";
import HeroAoVivo from "./HeroAoVivo";

export default function LandingPage() {
  // Rola até a seção quando se chega com hash na URL — é o caso de clicar em
  // "Clientes" no menu estando na página de podcast: o nav navega para "/#clientes"
  // e quem rola é esta página, depois de montar. O timeout existe porque o alvo
  // só existe depois do primeiro paint.
  const { hash: hashUrl } = useLocation();
  useEffect(() => {
    if (!hashUrl) return undefined;
    const alvo = hashUrl.slice(1);
    const t = setTimeout(() => {
      document.getElementById(alvo)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 80);
    return () => clearTimeout(t);
  }, [hashUrl]);

  const biRef = useRef(null);
  const [biVisible, setBiVisible] = useState(false);
  const [biC, setBiC] = useState({ total:0, interact:0, reclam:0, elogios:0, pautas:0, hourly:0 });

  useEffect(() => {
    const el = biRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setBiVisible(true); obs.disconnect(); }
    }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!biVisible) return;
    const dur = 1100; let t0 = null; let raf;
    const anim = (ts) => {
      if (!t0) t0 = ts;
      const p = Math.min((ts - t0) / dur, 1);
      const e = 1 - Math.pow(1 - p, 3);
      setBiC({ total:Math.round(e*680), interact:Math.round(e*52), reclam:Math.round(e*52), elogios:Math.round(e*15), pautas:Math.round(e*16), hourly:Math.round(e*71) });
      if (p < 1) raf = requestAnimationFrame(anim);
    };
    raf = requestAnimationFrame(anim);
    return () => cancelAnimationFrame(raf);
  }, [biVisible]);

  const editorRef = useRef(null);
  const [editorVisible, setEditorVisible] = useState(false);
  const [editorY, setEditorY] = useState(0);
  const [editorOp, setEditorOp] = useState(0);

  useEffect(() => {
    const el = editorRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setEditorVisible(true); obs.disconnect(); }
    }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!editorVisible) return;
    const dur = 900; let t0 = null; let raf;
    const anim = (ts) => {
      if (!t0) t0 = ts;
      const p = Math.min((ts - t0) / dur, 1);
      const e = 1 - Math.pow(1 - p, 3);
      setEditorY(Math.round(e * 480));
      setEditorOp(Math.round(e * 100));
      if (p < 1) raf = requestAnimationFrame(anim);
    };
    setTimeout(() => { raf = requestAnimationFrame(anim); }, 600);
    return () => cancelAnimationFrame(raf);
  }, [editorVisible]);

  const laminasRef = useRef(null);
  const [laminasVisible, setLaminasVisible] = useState(false);
  const [enqueteW, setEnqueteW] = useState(0);
  const [sorteioPhase, setSorteioPhase] = useState(0);
  const [spinIdx, setSpinIdx] = useState(0);

  useEffect(() => {
    const el = laminasRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) { setLaminasVisible(true); obs.disconnect(); }
    }, { threshold: 0.15 });
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  useEffect(() => {
    if (!laminasVisible) return;
    const t = setTimeout(() => setEnqueteW(81), 500);
    return () => clearTimeout(t);
  }, [laminasVisible]);

  useEffect(() => {
    if (!laminasVisible) return;
    const NAMES = ["Ana R.","Carlos S.","Fernanda M.","João P.","Maria L.","Pedro A.","Sandra K.","Bruno T.","Carla F.","Diego N."];
    let i = 0, iv;
    iv = setInterval(() => { i = (i + 1) % NAMES.length; setSpinIdx(i); }, 90);
    const t1 = setTimeout(() => { clearInterval(iv); iv = setInterval(() => { i = (i + 1) % NAMES.length; setSpinIdx(i); }, 230); }, 1800);
    const t2 = setTimeout(() => { clearInterval(iv); setSorteioPhase(1); }, 2800);
    return () => { clearInterval(iv); clearTimeout(t1); clearTimeout(t2); };
  }, [laminasVisible]);

  return (
    <div style={PAGINA_PUBLICA_STYLE}>

      <LandingNav />

      {/* HERO */}
      <section className="hero-grid" style={{
        paddingTop: "clamp(120px, 22vh, 200px)",
        paddingBottom: "4rem",
        paddingLeft: "clamp(1.5rem, 8vw, 9rem)",
        paddingRight: "clamp(1.5rem, 8vw, 9rem)",
        display: "grid",
        gridTemplateColumns: "minmax(0, 820px) minmax(260px, 1fr)",
        gap: "2rem",
        alignItems: "center",
      }}>
        <div>
          <h1 style={{
            fontSize: "clamp(2.8rem, 6.5vw, 5.5rem)",
            fontWeight: 700,
            lineHeight: 1.08,
            letterSpacing: "-0.04em",
            margin: "0 0 1.5rem",
            color: "#fff",
            maxWidth: 820,
          }}>
            Engajamento em tempo real para TV, podcasts e eventos ao vivo
          </h1>
  
          <p style={{
            fontSize: "clamp(1rem, 1.5vw, 1.2rem)",
            color: "rgba(255,255,255,0.45)",
            maxWidth: 480,
            margin: "0 0 2.5rem",
            lineHeight: 1.65,
            fontWeight: 400,
            letterSpacing: "0.01em",
          }}>
            Transforme a audiência em participante. Receba mensagens, modere e exiba ao vivo — para emissoras de TV, podcasters e criadores de conteúdo.
          </p>
  
          <div style={{ display: "flex", alignItems: "center", gap: "1.5rem", flexWrap: "wrap" }}>
            <RouterLink
              to="/account/register"
              style={{
                background: ACCENT,
                color: "#0a0a0a",
                textDecoration: "none",
                fontWeight: 600,
                fontSize: "0.9rem",
                padding: "0.6rem 1.4rem",
                borderRadius: 8,
                letterSpacing: "0.01em",
              }}
            >
              Começar grátis
            </RouterLink>
            <RouterLink
              to="/account/login"
              style={{
                color: "rgba(255,255,255,0.5)",
                textDecoration: "none",
                fontSize: "0.875rem",
                fontWeight: 400,
                letterSpacing: "0.01em",
                display: "flex",
                alignItems: "center",
                gap: "0.3rem",
              }}
            >
              Já tenho conta <span style={{ fontSize: "1rem" }}>→</span>
            </RouterLink>
          </div>
          <div style={{ marginTop: "1.5rem", fontSize: "0.82rem", color: "rgba(255,255,255,0.22)", display: "flex", alignItems: "center", gap: "0.5rem", flexWrap: "wrap" }}>
            Sua transmissão ao vivo começa de graça
            <span style={{ color: "rgba(255,255,255,0.1)" }}>·</span>
            <RouterLink to="/planos" style={{ color: "rgba(255,255,255,0.4)", textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "0.2rem" }}>
              Ver planos <span style={{ fontSize: "0.9rem" }}>→</span>
            </RouterLink>
          </div>
        </div>

        <HeroAoVivo />
      </section>


      <VitrineEstilos />

      {/* EMISSORAS — vitrine em video/GIF.
          Entra logo depois do HERO: e o material que responde "o que isso faz
          numa emissora?", pergunta que vinha ficando para o fim da pagina.
          Os arquivos estao em public/landing/ e nao sao importados por
          `import` - ver o cabecalho de VitrineProduto.jsx. */}
      <section id="emissoras" style={{ padding: "2rem clamp(1.5rem, 8vw, 9rem) 5rem" }}>
        <TituloSecao
          etiqueta="Para emissoras de TV"
          titulo="Da mensagem do telespectador ao ar, sem passar por ninguém"
          subtitulo="O público manda pelo WhatsApp, a equipe modera, e o conteúdo vai para a tela em segundos — com os gráficos, mapas e enquetes que o programa precisa."
        />

        <div style={{ display: "flex", flexDirection: "column", gap: "clamp(3rem, 7vw, 5.5rem)" }}>
          <VideoDestaque
            titulo="Mural Interativo no ar"
            descricao="As mensagens do público entram na tela em tempo real, com enquete, sorteio e nuvem de participantes — tudo controlado pela equipe durante o programa."
            src="/landing/videos/mural-interativo.mp4"
            gif="/landing/gifs/mural-interativo.gif"
            poster="/landing/posters/mural-interativo.jpg"
          />
          <VideoDestaque
            invertido
            titulo="Mapas e previsão do tempo prontos para o ar"
            descricao="Mapas ilustrados do estado, previsão por cidade e alertas de tempestade, montados no editor e atualizados sozinhos antes do telejornal."
            src="/landing/videos/mapas-ilustrados-tempestade.mp4"
            gif="/landing/gifs/mapas-ilustrados-tempestade.gif"
            poster="/landing/posters/mapas-ilustrados-tempestade.jpg"
          />
          <VideoDestaque
            titulo="Moderação antes de qualquer coisa ir ao ar"
            descricao="Toda mensagem passa pela equipe. O que entra na tela é escolha de quem está na régie, não do público."
            src="/landing/videos/moderacao-whatsapp.mp4"
            gif="/landing/gifs/moderacao-whatsapp.gif"
            poster="/landing/posters/moderacao-whatsapp.jpg"
          />
        </div>

        {/* Os GIFs rodam sozinhos: sao para o olho passar e entender em dois
            segundos, enquanto o video com locucao e para quem parou e quer
            ouvir. */}
        <div
          style={{
            marginTop: "clamp(3rem, 7vw, 5.5rem)",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(290px, 1fr))",
            gap: "1.5rem",
          }}
        >
          <CardGif
            titulo="Grid de mensagens"
            descricao="Várias participações na tela ao mesmo tempo, em colunas montadas no editor de layouts."
            src="/landing/gifs/grid-de-mensagens.gif"
          />
          <CardGif
            titulo="Conteúdo com IA"
            descricao="A IA monta a lâmina a partir da notícia e ajusta o texto que não couber no espaço."
            src="/landing/gifs/conteudo-e-conteudo-ia.gif"
          />
          <CardGif
            titulo="Corretor GPT"
            descricao="Corrige a mensagem do telespectador antes de ir ao ar, sem mudar o que a pessoa quis dizer."
            src="/landing/gifs/corretor-gpt.gif"
          />
          <CardGif
            titulo="Relatórios e BI"
            descricao="O que o público falou, por tema, bairro, programa e sentimento — em um painel só."
            src="/landing/gifs/relatorios-e-bi.gif"
          />
          <CardGif
            titulo="TV 3.0"
            descricao="Interatividade no receptor do telespectador: enquete na tela, participação e previsão da cidade dele."
            src="/landing/gifs/tv-3-0.gif"
          />
        </div>
      </section>

      {/* BI SECTION */}
      <section id="bi"
        ref={biRef}
        style={{ borderTop:"1px solid rgba(255,255,255,0.05)", padding:"6rem clamp(1.5rem,8vw,9rem) 10rem" }}
      >
        <div style={{ display:"inline-flex", alignItems:"center", gap:"0.5rem", background:"rgba(74,223,131,0.08)", border:"1px solid rgba(74,223,131,0.2)", borderRadius:9999, padding:"0.3rem 0.9rem", marginBottom:"1.5rem" }}>
          <span style={{ width:6, height:6, borderRadius:"50%", background:ACCENT, display:"inline-block" }} />
          <span style={{ fontSize:"0.75rem", fontWeight:600, color:ACCENT, letterSpacing:"0.06em", textTransform:"uppercase" }}>BI & Inteligência</span>
        </div>
        <div style={{ display:"flex", alignItems:"flex-end", justifyContent:"space-between", flexWrap:"wrap", gap:"2rem", marginBottom:"3rem" }}>
          <h2 style={{ fontSize:"clamp(2rem,4vw,3.6rem)", fontWeight:700, lineHeight:1.1, letterSpacing:"-0.035em", color:"#fff", margin:0, maxWidth:600 }}>
            A IA analisa cada mensagem. Você vê o que importa.
          </h2>
          <p style={{ fontSize:"0.95rem", color:"rgba(255,255,255,0.4)", maxWidth:340, lineHeight:1.7, margin:0 }}>
            Sentimento do público, temas mais citados, hora de pico e origem geográfica — tudo classificado automaticamente pela IA após cada transmissão.
          </p>
        </div>

        <div style={{ position:"relative", paddingBottom:"6rem" }}>
          {/* MAIN CARD */}
          <div style={{
            background:"#10121a", border:"1px solid rgba(255,255,255,0.09)", borderRadius:16,
            overflow:"hidden", padding:"1.25rem",
            boxShadow:"0 32px 100px rgba(0,0,0,0.7), inset 0 1px 0 rgba(255,255,255,0.06)",
            opacity: biVisible ? 1 : 0,
            transform: biVisible ? "translateY(0)" : "translateY(24px)",
            transition:"opacity 0.7s ease, transform 0.7s ease",
          }}>
            {/* KPI row */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(5,1fr)", gap:"0.6rem", marginBottom:"0.8rem" }}>
              {[
                { label:"Total",        val:biC.total,    badge:"↑ 128" },
                { label:"Interações",   val:biC.interact },
                { label:"Reclamações",  val:biC.reclam,   badge:"↑ 6" },
                { label:"Elogios",      val:biC.elogios },
                { label:"Pautas",       val:biC.pautas,   badge:"↑ 5" },
              ].map(k => (
                <div key={k.label} style={{ background:"rgba(255,255,255,0.03)", border:"1px solid rgba(255,255,255,0.05)", borderRadius:10, padding:"0.75rem 0.85rem" }}>
                  <div style={{ fontSize:"0.52rem", fontWeight:700, letterSpacing:"0.1em", textTransform:"uppercase", color:"rgba(255,255,255,0.22)", marginBottom:"0.3rem" }}>{k.label}</div>
                  <div style={{ fontSize:"1.5rem", fontWeight:700, letterSpacing:"-0.04em", color:"#fff", lineHeight:1, marginBottom:"0.3rem", fontVariantNumeric:"tabular-nums" }}>{k.val}</div>
                  {k.badge && <span style={{ display:"inline-flex", fontSize:"0.52rem", fontWeight:600, color:ACCENT, background:"rgba(74,223,131,0.1)", borderRadius:9999, padding:"0.1rem 0.4rem" }}>{k.badge}</span>}
                </div>
              ))}
            </div>

            {/* Charts row: donut + 2 bar charts */}
            <div style={{ display:"grid", gridTemplateColumns:"200px 1fr 1fr", gap:"0.65rem", marginBottom:"0.65rem" }}>
              {/* Donut */}
              <div style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.05)", borderRadius:10, padding:"0.75rem 0.85rem" }}>
                <div style={{ fontSize:"0.62rem", fontWeight:700, color:"rgba(255,255,255,0.65)", marginBottom:"0.1rem" }}>Tema principal</div>
                <div style={{ fontSize:"0.54rem", color:"rgba(255,255,255,0.22)", marginBottom:"0.65rem" }}>Distribuição por assunto</div>
                <div style={{ display:"flex", alignItems:"center", gap:"0.7rem" }}>
                  <div style={{
                    width:84, height:84, borderRadius:"50%", flexShrink:0, position:"relative",
                    background:"conic-gradient(#00b894 0deg 110.5deg,#6c5ce7 110.5deg 175.6deg,#e17055 175.6deg 230.8deg,#fdcb6e 230.8deg 274.1deg,#0984e3 274.1deg 302.2deg,#00cec9 302.2deg 317.3deg,#a29bfe 317.3deg 328.1deg,#fd79a8 328.1deg 341deg,#74b9ff 341deg 360deg)",
                    transform: biVisible ? "scale(1) rotate(0deg)" : "scale(0) rotate(-180deg)",
                    transition:"transform 1s cubic-bezier(0.34,1.56,0.64,1) 0.3s",
                  }}>
                    <div style={{ position:"absolute", top:"50%", left:"50%", transform:"translate(-50%,-50%)", width:50, height:50, borderRadius:"50%", background:"#10121a" }} />
                  </div>
                  <div style={{ flex:1, display:"flex", flexDirection:"column", gap:"0.22rem" }}>
                    {[["#00b894","Serviços públicos","30.7%"],["#6c5ce7","Cultura","18.1%"],["#e17055","Saúde","15.1%"],["#fdcb6e","Infraestrutura","12.0%"],["#0984e3","Segurança","7.8%"],["#00cec9","Emprego","4.2%"]].map(([c,l,p]) => (
                      <div key={l} style={{ display:"flex", alignItems:"center", gap:"0.28rem", fontSize:"0.52rem", color:"rgba(255,255,255,0.38)" }}>
                        <span style={{ width:6, height:6, borderRadius:"50%", background:c, flexShrink:0 }} />
                        {l}<span style={{ marginLeft:"auto", color:"rgba(255,255,255,0.2)" }}>{p}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Secundários + Bairros */}
              {[
                { title:"Secundários", sub:"Top assuntos por volume", bars:[
                  { name:"Serviços públicos", bw:"100%", c:"#00b894", n:51 },
                  { name:"Cultura",           bw:"59%",  c:"#6c5ce7", n:30 },
                  { name:"Saúde",             bw:"49%",  c:"#e17055", n:25 },
                  { name:"Infraestrutura",    bw:"39%",  c:"#fdcb6e", n:20 },
                  { name:"Segurança",         bw:"25%",  c:"#0984e3", n:13 },
                  { name:"Emprego",           bw:"14%",  c:"#00cec9", n:7  },
                  { name:"Mobilidade",        bw:"10%",  c:"#a29bfe", n:5  },
                  { name:"Educação",          bw:"10%",  c:"#fd79a8", n:5  },
                ]},
                { title:"Bairros", sub:"Origem das mensagens", bars:[
                  { name:"Mangabeira",    bw:"100%", c:"#4a6cf7", n:15 },
                  { name:"Bessa",         bw:"40%",  c:"#4a6cf7", n:6  },
                  { name:"Geisel",        bw:"40%",  c:"#4a6cf7", n:6  },
                  { name:"Aeroclube",     bw:"40%",  c:"#4a6cf7", n:6  },
                  { name:"Jardim Luna",   bw:"33%",  c:"#4a6cf7", n:5  },
                  { name:"Cristo",        bw:"33%",  c:"#4a6cf7", n:5  },
                  { name:"Jaguaribe",     bw:"33%",  c:"#4a6cf7", n:5  },
                  { name:"Colinas do Sul",bw:"33%",  c:"#4a6cf7", n:5  },
                ]},
              ].map(chart => (
                <div key={chart.title} style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.05)", borderRadius:10, padding:"0.75rem 0.85rem" }}>
                  <div style={{ fontSize:"0.62rem", fontWeight:700, color:"rgba(255,255,255,0.65)", marginBottom:"0.1rem" }}>{chart.title}</div>
                  <div style={{ fontSize:"0.54rem", color:"rgba(255,255,255,0.22)", marginBottom:"0.65rem" }}>{chart.sub}</div>
                  <div style={{ display:"flex", flexDirection:"column", gap:"0.38rem" }}>
                    {chart.bars.map((b, bi) => (
                      <div key={b.name} style={{ display:"flex", alignItems:"center", gap:"0.45rem" }}>
                        <span style={{ fontSize:"0.54rem", color:"rgba(255,255,255,0.38)", width:90, flexShrink:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{b.name}</span>
                        <div style={{ flex:1, height:5, background:"rgba(255,255,255,0.06)", borderRadius:3, overflow:"hidden", position:"relative" }}>
                          <div style={{ position:"absolute", top:0, left:0, height:"100%", borderRadius:3, background:b.c, width: biVisible ? b.bw : 0, transition:`width 1.3s cubic-bezier(0.4,0,0.2,1) ${biVisible ? (0.3 + bi * 0.04) + "s" : "0s"}` }} />
                        </div>
                        <span style={{ fontSize:"0.54rem", color:"rgba(255,255,255,0.26)", width:24, textAlign:"right", flexShrink:0, fontVariantNumeric:"tabular-nums" }}>{b.n}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            {/* Bottom row */}
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"0.6rem" }}>
              {[
                { title:"Programas", bars:[
                  { name:"Não identificado", bw:"100%", c:"#4a6cf7", n:"58.8%" },
                  { name:"Bom Dia Paraíba",  bw:"48%",  c:"#4a6cf7", n:"27.9%" },
                  { name:"JPB1",             bw:"22%",  c:"#4a6cf7", n:"13.2%" },
                ]},
                { title:"Apresentadores", bars:[
                  { name:"Não identificado", bw:"100%", c:ACCENT, n:"44.1%" },
                  { name:"Denise",           bw:"40%",  c:ACCENT, n:"17.6%" },
                  { name:"Fábio",            bw:"20%",  c:ACCENT, n:"8.8%"  },
                  { name:"Amy Nascimento",   bw:"14%",  c:ACCENT, n:"5.9%"  },
                ]},
                { title:"Sentimento · IA", bars:[
                  { name:"Negativo", bw:"100%", c:"#e17055", n:"43.2%" },
                  { name:"Neutro",   bw:"82%",  c:"#fdcb6e", n:"35.6%" },
                  { name:"Positivo", bw:"39%",  c:ACCENT,    n:"16.8%" },
                  { name:"Misto",    bw:"10%",  c:"#a29bfe", n:"4.4%"  },
                ]},
                { title:"Tipo de mensagem · IA", bars:[
                  { name:"Reclamação",        bw:"100%", c:"#e17055", n:"41.5%" },
                  { name:"Interação",         bw:"65%",  c:ACCENT,    n:"26.8%" },
                  { name:"Sugestão de pauta", bw:"45%",  c:ACCENT,    n:"18.5%" },
                  { name:"Elogio",            bw:"25%",  c:"#fdcb6e", n:"10.3%" },
                ]},
              ].map((panel, pi) => (
                <div key={panel.title} style={{ background:"rgba(255,255,255,0.02)", border:"1px solid rgba(255,255,255,0.05)", borderRadius:10, padding:"0.75rem 0.85rem" }}>
                  <div style={{ fontSize:"0.62rem", fontWeight:700, color:"rgba(255,255,255,0.65)", marginBottom:"0.6rem" }}>{panel.title}</div>
                  <div style={{ display:"flex", flexDirection:"column", gap:"0.38rem" }}>
                    {panel.bars.map((b, bi) => (
                      <div key={b.name} style={{ display:"flex", alignItems:"center", gap:"0.45rem" }}>
                        <span style={{ fontSize:"0.54rem", color:"rgba(255,255,255,0.38)", width:90, flexShrink:0, overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{b.name}</span>
                        <div style={{ flex:1, height:5, background:"rgba(255,255,255,0.06)", borderRadius:3, overflow:"hidden", position:"relative" }}>
                          <div style={{ position:"absolute", top:0, left:0, height:"100%", borderRadius:3, background:b.c, width: biVisible ? b.bw : 0, transition:`width 1.3s cubic-bezier(0.4,0,0.2,1) ${biVisible ? (0.4 + pi * 0.06 + bi * 0.04) + "s" : "0s"}` }} />
                        </div>
                        <span style={{ fontSize:"0.5rem", color:"rgba(255,255,255,0.26)", width:32, textAlign:"right", flexShrink:0 }}>{b.n}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* HOURLY DETAIL CARD */}
          <div style={{
            position:"absolute", bottom:0, right:"-1rem", width:"54%",
            background:"#10121a", border:"1px solid rgba(255,255,255,0.11)",
            borderRadius:14, padding:"1rem 1.1rem",
            boxShadow:"0 20px 70px rgba(0,0,0,0.9), 0 0 0 1px rgba(255,255,255,0.04), inset 0 1px 0 rgba(255,255,255,0.06)",
            opacity: biVisible ? 1 : 0,
            transform: biVisible ? "rotate(2deg) translateY(0)" : "rotate(2deg) translateY(24px)",
            transition:"opacity 0.8s ease 0.45s, transform 0.8s ease 0.45s",
            zIndex:2,
          }}>
            <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:"0.5rem", marginBottom:"0.75rem" }}>
              {[
                { label:"Total de mensagens", val:biC.hourly },
                { label:"Hora de pico",       val:"08h", badge:"19 msg" },
                { label:"Média por hora",     val:"3.0" },
                { label:"Horas c/ atividade", val:"10",  sub:"/24h" },
              ].map((k, i) => (
                <div key={i}>
                  <div style={{ fontSize:"0.5rem", fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:"rgba(255,255,255,0.2)", marginBottom:"0.2rem" }}>{k.label}</div>
                  <div style={{ fontSize:"1.05rem", fontWeight:700, color:"#fff", letterSpacing:"-0.03em", fontVariantNumeric:"tabular-nums" }}>
                    {k.val}
                    {k.badge && <span style={{ display:"inline-flex", alignItems:"center", background:"rgba(74,223,131,0.12)", border:"1px solid rgba(74,223,131,0.25)", borderRadius:9999, padding:"0.1rem 0.35rem", fontSize:"0.48rem", fontWeight:600, color:ACCENT, marginLeft:"0.25rem", verticalAlign:"middle" }}>{k.badge}</span>}
                    {k.sub && <span style={{ fontSize:"0.65em", color:"rgba(255,255,255,0.3)" }}>{k.sub}</span>}
                  </div>
                </div>
              ))}
            </div>
            <div style={{ borderTop:"1px solid rgba(255,255,255,0.06)", paddingTop:"0.7rem" }}>
              <div style={{ fontSize:"0.58rem", fontWeight:700, color:"rgba(255,255,255,0.55)", marginBottom:"0.5rem" }}>Distribuição por Horário</div>
              <div style={{ display:"flex", alignItems:"flex-end", gap:3, height:75 }}>
                {[{h:"63%",v:"12"},{h:"16%",v:"3"},{h:"5%",v:"1"},{h:"11%",v:"2"},{h:"1%"},{h:"16%",v:"3"},{h:"16%",v:"3"},{h:"37%",v:"7"},{h:"100%",v:"19",peak:true},{h:"63%",v:"12"},{h:"47%",v:"9"},{h:"1%"},{h:"1%"},{h:"1%"}].map((bar, i) => (
                  <div key={i} style={{
                    flex:1, height:bar.h, borderRadius:"3px 3px 0 0",
                    background: bar.peak ? "rgba(74,223,131,0.72)" : "rgba(74,223,131,0.2)",
                    transform: biVisible ? "scaleY(1)" : "scaleY(0)",
                    transformOrigin:"bottom",
                    transition:`transform 0.7s cubic-bezier(0.4,0,0.2,1) ${biVisible ? (0.55 + i * 0.05) + "s" : "0s"}`,
                    position:"relative", minWidth:0,
                  }}>
                    {bar.v && <span style={{ position:"absolute", top:-12, left:"50%", transform:"translateX(-50%)", fontSize:"0.42rem", color: bar.peak ? "rgba(255,255,255,0.85)" : "rgba(255,255,255,0.45)", fontVariantNumeric:"tabular-nums", whiteSpace:"nowrap" }}>{bar.v}</span>}
                  </div>
                ))}
              </div>
              <div style={{ display:"flex", gap:3, marginTop:"0.3rem" }}>
                {["00h","01h","02h","03h","04h","05h","06h","07h","08h","09h","10h","11h","12h","13h"].map((lbl, i) => (
                  <span key={lbl} style={{ flex:1, textAlign:"center", fontSize:"0.42rem", color: i===8 ? "rgba(74,223,131,0.65)" : "rgba(255,255,255,0.18)" }}>{lbl}</span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* EDITOR DE LAYOUTS SECTION */}
      <section
        ref={editorRef}
        style={{ borderTop:"1px solid rgba(255,255,255,0.05)", padding:"6rem clamp(1.5rem,8vw,9rem) 7rem" }}
      >
        <div style={{ display:"grid", gridTemplateColumns:"1fr 1.5fr", gap:"4rem", alignItems:"center", maxWidth:1200, margin:"0 auto" }}>
          {/* Text */}
          <div>
            <div style={{ display:"inline-flex", alignItems:"center", gap:"0.5rem", background:"rgba(74,223,131,0.08)", border:"1px solid rgba(74,223,131,0.2)", borderRadius:9999, padding:"0.3rem 0.9rem", marginBottom:"1.5rem" }}>
              <span style={{ width:6, height:6, borderRadius:"50%", background:ACCENT, display:"inline-block" }} />
              <span style={{ fontSize:"0.75rem", fontWeight:600, color:ACCENT, letterSpacing:"0.06em", textTransform:"uppercase" }}>Editor de layouts</span>
            </div>
            <h2 style={{ fontSize:"clamp(2rem,4vw,3.2rem)", fontWeight:700, lineHeight:1.1, letterSpacing:"-0.035em", color:"#fff", margin:"0 0 1rem", maxWidth:500 }}>
              Arraste, solte e a IA refina. Seu layout pronto em segundos.
            </h2>
            <p style={{ fontSize:"0.95rem", color:"rgba(255,255,255,0.4)", lineHeight:1.7, margin:0, maxWidth:400 }}>
              Monte a identidade visual da sua transmissão com um editor visual drag-and-drop. A IA sugere elementos, ajusta posições e mantém a consistência da sua marca automaticamente.
            </p>
          </div>

          {/* Editor card */}
          <div style={{
            background:"#111", border:"1px solid rgba(255,255,255,0.08)", borderRadius:12, overflow:"hidden",
            opacity: editorVisible ? 1 : 0,
            transform: editorVisible ? "translateY(0)" : "translateY(24px)",
            transition:"opacity 0.8s ease, transform 0.8s ease",
            boxShadow:"0 32px 80px rgba(0,0,0,0.6)",
          }}>
            {/* Topbar */}
            <div style={{ display:"flex", alignItems:"center", gap:"0.45rem", padding:"0.6rem 0.9rem", borderBottom:"1px solid rgba(255,255,255,0.06)", background:"#0d0d0d" }}>
              {[["#ff5f57"],["#febc2e"],["#28c840"]].map(([c],i) => (
                <span key={i} style={{ width:8, height:8, borderRadius:"50%", background:c, display:"inline-block" }} />
              ))}
              <span style={{ margin:"0 auto", fontSize:"0.68rem", color:"rgba(255,255,255,0.3)", letterSpacing:"0.04em" }}>
                Layout Editor — Jornal da Manhã
              </span>
            </div>

            {/* 3 panels */}
            <div style={{ display:"grid", gridTemplateColumns:"180px 1fr 170px", height:320 }}>

              {/* Layers panel */}
              <div style={{ borderRight:"1px solid rgba(255,255,255,0.06)", overflow:"hidden" }}>
                <div style={{ fontSize:"0.6rem", fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:"rgba(255,255,255,0.3)", padding:"0.55rem 0.75rem 0.35rem", borderBottom:"1px solid rgba(255,255,255,0.04)" }}>Camadas</div>
                {[
                  { name:"TV Background", icon:"rect",    badge:null,  delay:0.1 },
                  { name:"Lower Third",   icon:"lt",      badge:"IA",  delay:0.18, active:true },
                  { name:"Logo",          icon:"circle",  badge:null,  delay:0.26 },
                  { name:"Ticker",        icon:"bar",     badge:"IA",  delay:0.34 },
                  { name:"Overlay escuro",icon:"fill",    badge:null,  delay:0.42 },
                ].map((layer) => (
                  <div key={layer.name} style={{
                    display:"flex", alignItems:"center", gap:"0.45rem",
                    padding:"0.42rem 0.7rem",
                    background: layer.active ? "rgba(74,223,131,0.06)" : "transparent",
                    borderLeft: layer.active ? `2px solid ${ACCENT}` : "2px solid transparent",
                    opacity: editorVisible ? 1 : 0,
                    transform: editorVisible ? "translateX(0)" : "translateX(-10px)",
                    transition:`opacity 0.4s ease ${layer.delay}s, transform 0.4s ease ${layer.delay}s`,
                  }}>
                    <svg width="13" height="13" viewBox="0 0 14 14" fill="none" style={{ flexShrink:0, opacity: layer.active ? 0.9 : 0.35, color: layer.active ? ACCENT : "#fff" }}>
                      {layer.icon === "rect"   && <rect x="1" y="1" width="12" height="12" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>}
                      {layer.icon === "lt"     && <><rect x="1" y="7" width="12" height="6" rx="1" fill="currentColor" opacity="0.3"/><rect x="1" y="7" width="12" height="6" rx="1" stroke="currentColor" strokeWidth="1.2"/></>}
                      {layer.icon === "circle" && <><circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.2"/><circle cx="7" cy="7" r="2" fill="currentColor" opacity="0.4"/></>}
                      {layer.icon === "bar"    && <rect x="1" y="11" width="12" height="2" rx="1" fill="currentColor" opacity="0.5"/>}
                      {layer.icon === "fill"   && <rect x="1" y="1" width="12" height="12" rx="1.5" fill="currentColor" opacity="0.2"/>}
                    </svg>
                    <span style={{ flex:1, fontSize:"0.69rem", color: layer.active ? "#fff" : "rgba(255,255,255,0.55)", whiteSpace:"nowrap", overflow:"hidden", textOverflow:"ellipsis" }}>{layer.name}</span>
                    {layer.badge && (
                      <span style={{ fontSize:"0.55rem", fontWeight:700, background:"rgba(74,223,131,0.15)", color:ACCENT, padding:"0.1rem 0.28rem", borderRadius:3, flexShrink:0 }}>{layer.badge}</span>
                    )}
                    <span style={{ fontSize:"0.6rem", opacity:0.2 }}>👁</span>
                  </div>
                ))}
              </div>

              {/* Canvas panel */}
              <div style={{ borderRight:"1px solid rgba(255,255,255,0.06)", display:"flex", alignItems:"center", justifyContent:"center", padding:"0.65rem", background:"#090909" }}>
                <div style={{ width:"100%", aspectRatio:"16/9", position:"relative", background:"linear-gradient(140deg,#0d1b2a 0%,#1b2838 60%,#0a1628 100%)", borderRadius:3, overflow:"hidden" }}>
                  {/* grid lines */}
                  <div style={{ position:"absolute", inset:0, backgroundImage:"repeating-linear-gradient(90deg,transparent,transparent 39px,rgba(255,255,255,0.018) 39px,rgba(255,255,255,0.018) 40px)" }} />
                  {/* Logo bug */}
                  <div style={{ position:"absolute", top:"6%", left:"5%", display:"flex", alignItems:"center", gap:4 }}>
                    <div style={{ width:16, height:16, borderRadius:"50%", background:ACCENT, display:"grid", placeItems:"center", fontSize:6, fontWeight:900, color:"#000" }}>Y</div>
                    <span style={{ fontSize:7, fontWeight:700, color:"rgba(255,255,255,0.7)", letterSpacing:"0.06em" }}>TV CANAL 10</span>
                  </div>
                  {/* Lower third (selected element) */}
                  <div style={{
                    position:"absolute", bottom:"14%", left:0, right:0, height:"20%",
                    display:"flex", alignItems:"center",
                    background:"linear-gradient(to right,rgba(0,0,0,0.88) 75%,transparent)",
                    opacity: editorVisible ? 1 : 0,
                    transform: editorVisible ? "translateY(0)" : "translateY(8px)",
                    transition:"opacity 0.6s ease 0.5s, transform 0.6s ease 0.5s",
                  }}>
                    <div style={{ width:3, height:"100%", background:ACCENT, marginRight:7, flexShrink:0 }} />
                    <div style={{ display:"flex", flexDirection:"column", gap:2 }}>
                      <span style={{ fontSize:"7.5px", fontWeight:700, color:"#fff" }}>Dr. Carlos Mendes</span>
                      <span style={{ fontSize:"5.5px", color:"rgba(255,255,255,0.5)" }}>Secretário de Saúde — João Pessoa</span>
                    </div>
                    {/* Selection outline */}
                    <div style={{ position:"absolute", inset:-2, border:"1.5px dashed rgba(74,223,131,0.65)", borderRadius:1, opacity: editorVisible ? 1 : 0, transition:"opacity 0.3s ease 0.9s", pointerEvents:"none" }}>
                      {[{top:-3,left:-3},{top:-3,right:-3},{bottom:-3,left:-3},{bottom:-3,right:-3}].map((pos,i) => (
                        <div key={i} style={{ position:"absolute", width:5, height:5, borderRadius:1, background:ACCENT, border:"1px solid #000", ...pos }} />
                      ))}
                    </div>
                  </div>
                  {/* Ticker */}
                  <div style={{
                    position:"absolute", bottom:0, left:0, right:0, height:"9%",
                    background:"rgba(74,223,131,0.88)", display:"flex", alignItems:"center", padding:"0 6px", gap:6,
                    opacity: editorVisible ? 1 : 0, transition:"opacity 0.5s ease 1s",
                  }}>
                    <span style={{ fontSize:5, fontWeight:800, color:"#000", letterSpacing:"0.06em", background:"rgba(0,0,0,0.22)", padding:"1px 3px", borderRadius:1, flexShrink:0 }}>AO VIVO</span>
                    <span style={{ fontSize:"5.5px", color:"#000", fontWeight:600, whiteSpace:"nowrap", overflow:"hidden" }}>Prefeitura anuncia obras na orla • Reunião de pautas às 10h • Envie sua mensagem pelo WhatsApp</span>
                  </div>
                </div>
              </div>

              {/* Properties panel */}
              <div style={{ overflow:"hidden" }}>
                <div style={{ fontSize:"0.6rem", fontWeight:600, letterSpacing:"0.08em", textTransform:"uppercase", color:"rgba(255,255,255,0.3)", padding:"0.55rem 0.75rem 0.35rem", borderBottom:"1px solid rgba(255,255,255,0.04)" }}>Propriedades</div>
                <div style={{ padding:"0.6rem 0.75rem", display:"flex", flexDirection:"column", gap:"0.55rem", overflowY:"auto", height:"calc(320px - 32px)" }}>
                  {[
                    { label:"Posição X",  value:"0 px",        delay:0.3  },
                    { label:"Posição Y",  value:`${editorY} px`, delay:0.38 },
                    { label:"Largura",    value:"1280 px",      delay:0.46 },
                    { label:"Opacidade",  value:`${editorOp}%`,  delay:0.54 },
                  ].map((prop) => (
                    <div key={prop.label}>
                      <div style={{ fontSize:"0.6rem", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.06em", color:"rgba(255,255,255,0.3)", marginBottom:"0.18rem" }}>{prop.label}</div>
                      <div style={{
                        fontSize:"0.74rem", color:"#fff",
                        background:"#0d0d0d", border:"1px solid rgba(255,255,255,0.07)",
                        borderRadius:4, padding:"0.22rem 0.45rem",
                        fontVariantNumeric:"tabular-nums",
                        opacity: editorVisible ? 1 : 0,
                        transform: editorVisible ? "translateX(0)" : "translateX(6px)",
                        transition:`opacity 0.4s ease ${prop.delay}s, transform 0.4s ease ${prop.delay}s`,
                      }}>{prop.value}</div>
                    </div>
                  ))}
                  {/* Color prop */}
                  <div>
                    <div style={{ fontSize:"0.6rem", fontWeight:600, textTransform:"uppercase", letterSpacing:"0.06em", color:"rgba(255,255,255,0.3)", marginBottom:"0.18rem" }}>Cor de fundo</div>
                    <div style={{
                      fontSize:"0.74rem", color:"#fff",
                      background:"#0d0d0d", border:"1px solid rgba(255,255,255,0.07)",
                      borderRadius:4, padding:"0.22rem 0.45rem",
                      display:"flex", alignItems:"center", gap:"0.3rem",
                      opacity: editorVisible ? 1 : 0,
                      transform: editorVisible ? "translateX(0)" : "translateX(6px)",
                      transition:"opacity 0.4s ease 0.62s, transform 0.4s ease 0.62s",
                    }}>
                      <span style={{ width:18, height:12, borderRadius:2, background:ACCENT, display:"inline-block", flexShrink:0 }} />
                      #4ADF83
                    </div>
                  </div>
                  {/* AI badge */}
                  <div style={{
                    display:"flex", alignItems:"center", gap:"0.3rem",
                    fontSize:"0.61rem", color:ACCENT,
                    background:"rgba(74,223,131,0.06)", border:"1px solid rgba(74,223,131,0.15)",
                    borderRadius:4, padding:"0.28rem 0.45rem",
                    opacity: editorVisible ? 1 : 0,
                    transform: editorVisible ? "scale(1)" : "scale(0.9)",
                    transition:"opacity 0.4s ease 1.15s, transform 0.4s ease 1.15s",
                  }}>
                    <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                      <circle cx="5" cy="5" r="4" stroke={ACCENT} strokeWidth="1.2"/>
                      <path d="M3 5l1.3 1.3L7 3.5" stroke={ACCENT} strokeWidth="1.2" strokeLinecap="round"/>
                    </svg>
                    Cor sugerida pela IA
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* LÂMINAS AO VIVO SECTION */}
      <style>{`
        @keyframes lam-float-a { 0%,100% { transform: translateY(0px) translate(-50%,-50%); } 50% { transform: translateY(-5px) translate(-50%,-50%); } }
        @keyframes lam-float-b { 0%,100% { transform: translateY(-3px) translateX(1px) translate(-50%,-50%); } 50% { transform: translateY(4px) translateX(-1px) translate(-50%,-50%); } }
        @keyframes lam-float-c { 0%,100% { transform: translateY(2px) translateX(-2px) translate(-50%,-50%); } 50% { transform: translateY(-4px) translateX(2px) translate(-50%,-50%); } }
        @keyframes lam-winner-pop { 0% { transform: scale(0.3) rotate(-10deg); opacity:0; } 70% { transform: scale(1.1) rotate(2deg); opacity:1; } 100% { transform: scale(1) rotate(0deg); opacity:1; } }
        @keyframes lam-confetti { 0% { transform: translateY(0) rotate(0deg); opacity:1; } 100% { transform: translateY(80px) rotate(720deg); opacity:0; } }
      `}</style>

      <section id="laminas"
        ref={laminasRef}
        style={{ borderTop:"1px solid rgba(255,255,255,0.05)", padding:"6rem clamp(1.5rem,8vw,9rem) 7rem" }}
      >
        <div style={{ marginBottom:"3.5rem" }}>
          <div style={{ display:"inline-flex", alignItems:"center", gap:"0.5rem", background:"rgba(74,223,131,0.08)", border:"1px solid rgba(74,223,131,0.2)", borderRadius:9999, padding:"0.3rem 0.9rem", marginBottom:"1.5rem" }}>
            <span style={{ width:6, height:6, borderRadius:"50%", background:ACCENT, display:"inline-block" }} />
            <span style={{ fontSize:"0.75rem", fontWeight:600, color:ACCENT, letterSpacing:"0.06em", textTransform:"uppercase" }}>Lâminas ao vivo</span>
          </div>
          <h2 style={{ fontSize:"clamp(2rem,4vw,3.2rem)", fontWeight:700, lineHeight:1.1, letterSpacing:"-0.035em", color:"#fff", margin:"0 0 1rem", maxWidth:700 }}>
            Enquete, sorteio e nuvem — na tela, ao vivo, em segundos.
          </h2>
          <p style={{ fontSize:"0.95rem", color:"rgba(255,255,255,0.4)", maxWidth:500, lineHeight:1.7, margin:0 }}>
            Telas especiais lançadas com um clique durante a transmissão. A IA classifica as respostas, identifica participantes e entrega o resultado em tempo real.
          </p>
        </div>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(3,1fr)", gap:"1.5rem" }}>

          {/* ── NUVEM DE PARTICIPANTES ── */}
          <div style={{ opacity: laminasVisible ? 1 : 0, transform: laminasVisible ? "translateY(0)" : "translateY(28px)", transition:"opacity 0.7s ease 0.1s, transform 0.7s ease 0.1s" }}>
            <div style={{ position:"relative", paddingBottom:"65%", borderRadius:14, overflow:"hidden", background:"radial-gradient(ellipse at 55% 45%, #dde8f5 0%, #c5d5eb 50%, #a8bed6 100%)", boxShadow:"0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.4)" }}>
              {/* logo JM1 */}
              <div style={{ position:"absolute", top:"5%", left:"4%", display:"flex", alignItems:"center", gap:2, zIndex:5 }}>
                <span style={{ fontWeight:900, fontSize:"clamp(9px,1.8vw,13px)", color:"#1a1a3e" }}>JM</span>
                <div style={{ background:"#f97316", width:"clamp(9px,1.8vw,13px)", height:"clamp(9px,1.8vw,13px)", display:"grid", placeItems:"center", borderRadius:2 }}>
                  <span style={{ fontWeight:900, fontSize:"clamp(7px,1.4vw,10px)", color:"#fff" }}>1</span>
                </div>
              </div>
              {/* bubbles */}
              {[
                // centro — vencedor
                { x:50, y:50, s:19, photo:"https://i.pravatar.cc/100?img=11", ring:true, fa:"a", d:0    },
                // anel interno (raio ~24)
                { x:50, y:26, s:13, photo:"https://i.pravatar.cc/100?img=32",            fa:"b", d:0.08 },
                { x:71, y:38, s:12, photo:"https://i.pravatar.cc/100?img=5",             fa:"c", d:0.15 },
                { x:71, y:62, s:12, photo:"https://i.pravatar.cc/100?img=22",            fa:"a", d:0.1  },
                { x:50, y:74, s:13, photo:"https://i.pravatar.cc/100?img=44",            fa:"b", d:0.25 },
                { x:29, y:62, s:12, photo:"https://i.pravatar.cc/100?img=18",            fa:"c", d:0.12 },
                { x:29, y:38, s:12, photo:"https://i.pravatar.cc/100?img=7",             fa:"a", d:0.18 },
                // anel externo (raio ~35)
                { x:83, y:50, s:9,  photo:"https://i.pravatar.cc/100?img=29",            fa:"b", d:0.3  },
                { x:67, y:15, s:10, col:"#fff", av:"TH+", logo:true, logoC:"#0891b2",   fa:"a", d:0.4  },
                { x:33, y:15, s:10, photo:"https://i.pravatar.cc/100?img=47",            fa:"c", d:0.35 },
                { x:17, y:50, s:9,  col:"#fff", av:"REC", logo:true, logoC:"#dc2626",   fa:"b", d:0.08 },
                { x:33, y:85, s:9,  photo:"https://i.pravatar.cc/100?img=13",            fa:"a", d:0.22 },
                { x:67, y:85, s:9,  photo:"https://i.pravatar.cc/100?img=56",            fa:"c", d:0.28 },
                // extras nas diagonais externas
                { x:83, y:25, s:8,  col:"#fff", av:"SBT", logo:true, logoC:"#1d4ed8",   fa:"b", d:0.45 },
                { x:83, y:75, s:8,  photo:"https://i.pravatar.cc/100?img=3",             fa:"c", d:0.38 },
                { x:17, y:25, s:8,  photo:"https://i.pravatar.cc/100?img=37",            fa:"a", d:0.33 },
                { x:17, y:75, s:8,  photo:"https://i.pravatar.cc/100?img=25",            fa:"b", d:0.2  },
              ].map((b, i) => (
                <div key={i} style={{
                  position:"absolute", left:`${b.x}%`, top:`${b.y}%`,
                  width:`${b.s}%`, aspectRatio:"1/1",
                  borderRadius:"50%",
                  background: b.logo ? b.col : "transparent",
                  border: b.logo ? "1.5px solid rgba(0,0,0,0.1)" : "none",
                  boxShadow: b.ring ? "0 0 0 2.5px #f59e0b, 0 0 0 5px rgba(245,158,11,0.3), 0 4px 15px rgba(0,0,0,0.25)" : "0 2px 8px rgba(0,0,0,0.2)",
                  display:"grid", placeItems:"center",
                  transform:"translate(-50%, -50%)",
                  animation: laminasVisible ? `lam-float-${b.fa} ${2.5+(i%3)*0.7}s ease-in-out ${b.d}s infinite alternate` : "none",
                  opacity: laminasVisible ? 1 : 0,
                  transition:`opacity 0.5s ease ${0.3+b.d}s`,
                  zIndex: b.ring ? 3 : i < 9 ? 2 : 1,
                  overflow: b.ring ? "visible" : "hidden",
                }}>
                  {b.ring && (
                    <div style={{ position:"absolute", top:"-52%", left:"50%", transform:"translateX(-50%)", fontSize:"1.9em", lineHeight:1, zIndex:10, filter:"drop-shadow(0 2px 6px rgba(0,0,0,0.55))", pointerEvents:"none" }}>👑</div>
                  )}
                  {b.photo
                    ? <img src={b.photo} alt="" style={{ width:"100%", height:"100%", objectFit:"cover", borderRadius:"50%", display:"block" }} />
                    : <span style={{ fontSize:`${b.s*0.3}cqw`, fontWeight:800, color: b.logoC, lineHeight:1, letterSpacing:"-0.03em" }}>{b.av}</span>
                  }
                </div>
              ))}
            </div>
            <div style={{ marginTop:"1rem", textAlign:"center" }}>
              <div style={{ fontSize:"0.9rem", fontWeight:600, color:"#fff" }}>Nuvem de Participantes</div>
              <div style={{ fontSize:"0.76rem", color:"rgba(255,255,255,0.38)", marginTop:"0.3rem" }}>Todos que enviaram mensagem — em destaque na tela</div>
            </div>
          </div>

          {/* ── ENQUETE ── */}
          <div style={{ opacity: laminasVisible ? 1 : 0, transform: laminasVisible ? "translateY(0)" : "translateY(28px)", transition:"opacity 0.7s ease 0.25s, transform 0.7s ease 0.25s" }}>
            <div style={{ position:"relative", paddingBottom:"65%", borderRadius:14, overflow:"hidden", background:"#f97316", boxShadow:"0 20px 60px rgba(0,0,0,0.5)" }}>
              <div style={{ position:"absolute", inset:0, padding:"clamp(10px,4%,20px)", display:"flex", flexDirection:"column", gap:"clamp(6px,2.5%,14px)" }}>
                <div style={{ background:"rgba(0,0,0,0.18)", borderRadius:6, padding:"clamp(7px,3%,14px) clamp(8px,3.5%,16px)" }}>
                  <p style={{ margin:0, fontSize:"clamp(9px,2vw,15px)", fontWeight:800, color:"#fff", textTransform:"uppercase", lineHeight:1.3, letterSpacing:"0.02em" }}>
                    Sobre o aumento de salário dos vereadores. Você concorda ou discorda?
                  </p>
                </div>
                <div style={{ display:"flex", flexDirection:"column", gap:"clamp(8px,3%,14px)", marginTop:"clamp(2px,1%,6px)" }}>
                  {[
                    { label:"#CONCORDO", pct:enqueteW,                          delay:"0.5s" },
                    { label:"#DISCORDO", pct:Math.max(0,Math.round(enqueteW*19/81)), delay:"0.7s" },
                  ].map((opt,i) => (
                    <div key={i}>
                      <div style={{ fontSize:"clamp(8px,1.7vw,12px)", fontWeight:700, color:"#fff", marginBottom:"clamp(3px,1%,5px)", letterSpacing:"0.03em" }}>{opt.label}</div>
                      <div style={{ background:"rgba(0,0,0,0.15)", borderRadius:4, overflow:"hidden", height:"clamp(12px,2.8%,22px)" }}>
                        <div style={{ width:`${opt.pct}%`, height:"100%", background:"#16a34a", borderRadius:4, transition:`width 1.4s cubic-bezier(0.34,1.56,0.64,1) ${opt.delay}`, display:"flex", alignItems:"center", justifyContent:"flex-end", paddingRight:6 }}>
                          {opt.pct > 12 && <span style={{ fontSize:"clamp(7px,1.5vw,11px)", fontWeight:700, color:"#fff" }}>{opt.pct}%</span>}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div style={{ marginTop:"1rem", textAlign:"center" }}>
              <div style={{ fontSize:"0.9rem", fontWeight:600, color:"#fff" }}>Enquete</div>
              <div style={{ fontSize:"0.76rem", color:"rgba(255,255,255,0.38)", marginTop:"0.3rem" }}>Pergunta lançada ao vivo — resultado atualizado em tempo real</div>
            </div>
          </div>

          {/* ── SORTEIO ── */}
          <div style={{ opacity: laminasVisible ? 1 : 0, transform: laminasVisible ? "translateY(0)" : "translateY(28px)", transition:"opacity 0.7s ease 0.4s, transform 0.7s ease 0.4s" }}>
            <div style={{ position:"relative", paddingBottom:"65%", borderRadius:14, overflow:"hidden", background:"linear-gradient(160deg,#0f0c29 0%,#302b63 60%,#24243e 100%)", boxShadow:"0 20px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.07)" }}>
              <div style={{ position:"absolute", inset:0, display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", gap:"clamp(4px,1.5%,10px)", padding:"clamp(8px,3%,16px)" }}>
                <div style={{ background:"linear-gradient(90deg,#f59e0b,#fbbf24)", borderRadius:6, padding:"clamp(3px,1.2%,7px) clamp(10px,4%,18px)" }}>
                  <span style={{ fontSize:"clamp(7px,1.6vw,12px)", fontWeight:800, color:"#000", letterSpacing:"0.1em", textTransform:"uppercase" }}>🎰 Sorteio ao Vivo</span>
                </div>
                <div style={{ fontSize:"clamp(6px,1.2vw,9px)", color:"rgba(255,255,255,0.35)", letterSpacing:"0.08em", textTransform:"uppercase" }}>
                  {laminasVisible ? "247 participantes" : "—"}
                </div>
                <div style={{
                  background:"rgba(255,255,255,0.05)", border:`1px solid ${sorteioPhase===1 ? "rgba(245,158,11,0.5)" : "rgba(255,245,200,0.15)"}`,
                  borderRadius:8, padding:"clamp(8px,3%,16px) clamp(14px,6%,30px)", minWidth:"65%", textAlign:"center",
                  boxShadow: sorteioPhase===1 ? "0 0 28px rgba(245,158,11,0.35), inset 0 0 18px rgba(245,158,11,0.08)" : "none",
                  transition:"box-shadow 0.5s ease, border-color 0.5s ease",
                }}>
                  {sorteioPhase===0
                    ? <span style={{ fontSize:"clamp(10px,2.5vw,18px)", fontWeight:700, color:"rgba(255,255,255,0.85)", fontVariantNumeric:"tabular-nums" }}>
                        {["Ana R.","Carlos S.","Fernanda M.","João P.","Maria L.","Pedro A.","Sandra K.","Bruno T.","Carla F.","Diego N."][spinIdx]}
                      </span>
                    : <span style={{ fontSize:"clamp(10px,2.5vw,18px)", fontWeight:800, color:"#fbbf24", display:"block", animation:"lam-winner-pop 0.5s cubic-bezier(0.34,1.56,0.64,1) both" }}>
                        🏆 Maria Lima
                      </span>
                  }
                </div>
                {sorteioPhase===0 && laminasVisible && (
                  <span style={{ fontSize:"clamp(5px,1.1vw,8px)", color:"rgba(255,255,255,0.22)", letterSpacing:"0.1em", textTransform:"uppercase" }}>Sorteando...</span>
                )}
                {sorteioPhase===1 && (
                  <span style={{ fontSize:"clamp(6px,1.1vw,9px)", color:"rgba(255,255,255,0.4)", letterSpacing:"0.04em" }}>Mensagem às 20:31 — Porto Alegre, RS</span>
                )}
                {/* confetti */}
                {sorteioPhase===1 && (
                  <div style={{ position:"absolute", inset:0, pointerEvents:"none", overflow:"hidden" }}>
                    {[...Array(16)].map((_,i) => (
                      <div key={i} style={{
                        position:"absolute", left:`${8+(i*6)%84}%`, top:`${(i*11)%35}%`,
                        width: i%3===0?7:i%3===1?5:4, height: i%3===0?7:i%3===1?5:4,
                        borderRadius: i%2===0?"50%":2,
                        background:["#f59e0b","#ec4899","#22d3ee","#a3e635","#f97316","#c084fc"][i%6],
                        animation:`lam-confetti ${0.7+(i%4)*0.25}s ease-out ${(i*0.09)}s both`,
                      }} />
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div style={{ marginTop:"1rem", textAlign:"center" }}>
              <div style={{ fontSize:"0.9rem", fontWeight:600, color:"#fff" }}>Sorteio</div>
              <div style={{ fontSize:"0.76rem", color:"rgba(255,255,255,0.38)", marginTop:"0.3rem" }}>Sorteie entre os participantes ao vivo — transparente e instantâneo</div>
            </div>
          </div>

        </div>
      </section>

      {/* CLIENTES SECTION */}
      <section id="clientes" style={{ padding: "5rem 0 4rem", overflow: "hidden" }}>
        <style>{`
          @keyframes clients-fwd {
            0%   { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
          @keyframes clients-bwd {
            0%   { transform: translateX(-50%); }
            100% { transform: translateX(0); }
          }
          .clients-track-fwd { animation: clients-fwd 40s linear infinite; }
          .clients-track-bwd { animation: clients-bwd 40s linear infinite; }
          .clients-track-fwd:hover,
          .clients-track-bwd:hover { animation-play-state: paused; }
          .clients-logo-wrap img { filter: grayscale(100%) brightness(0.7); transition: filter 0.3s; }
          .clients-logo-wrap:hover img { filter: grayscale(0%) brightness(1); }
        `}</style>

        <div style={{
          textAlign: "center",
          marginBottom: "3rem",
          padding: "0 clamp(1.5rem, 8vw, 9rem)",
        }}>
          <span style={{
            display: "inline-block",
            fontSize: "0.7rem",
            fontWeight: 700,
            letterSpacing: "0.14em",
            textTransform: "uppercase",
            color: ACCENT,
            marginBottom: "0.75rem",
          }}>Clientes</span>
          <h2 style={{
            fontSize: "clamp(1.8rem, 3.5vw, 2.8rem)",
            fontWeight: 700,
            letterSpacing: "-0.03em",
            margin: "0 0 0.75rem",
            color: "#fff",
          }}>Quem já usa o Youon</h2>
          <p style={{
            fontSize: "clamp(0.9rem, 1.2vw, 1rem)",
            color: "rgba(255,255,255,0.35)",
            margin: 0,
          }}>Mais de 150 emissoras, podcasts e eventos em todo o Brasil</p>
        </div>

        {/* fade edges */}
        <div style={{ position: "relative" }}>
          <div style={{
            position: "absolute", left: 0, top: 0, bottom: 0, width: 120,
            background: "linear-gradient(to right, #0a0a0a, transparent)",
            zIndex: 2, pointerEvents: "none",
          }} />
          <div style={{
            position: "absolute", right: 0, top: 0, bottom: 0, width: 120,
            background: "linear-gradient(to left, #0a0a0a, transparent)",
            zIndex: 2, pointerEvents: "none",
          }} />

          {/* Faixa 1 — esquerda */}
          <div className="clients-track-fwd" style={{ display: "flex", gap: "1rem", width: "max-content", marginBottom: "1rem" }}>
            {[
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-05_4_1314648642.png", alt: "ND TV" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-sbt-rede-massa.png", alt: "Rede Massa SBT" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-aparecida.png", alt: "TV Aparecida" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-sictvrecord.png", alt: "SIC TV Record" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-anhanguera.png", alt: "TV Anhanguera" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-pajucara.png", alt: "TV Pajuçara" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-redetvrn.png", alt: "Rede TV RN" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-band.png", alt: "Grupo Bandeirantes" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-sbt-hdtv.png", alt: "SBT Santa Catarina" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-15_4_1264733846.png", alt: "Antena 10" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-55_4_1179154877.png", alt: "Band Natal" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-01_4_436039229.png", alt: "Band Piauí" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-32_4_1032820651.png", alt: "Band RJ Interior" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-40_4_89120446.png", alt: "Band Campinas" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-10_4_330940411.png", alt: "Band Sports" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-39_4_1788310047.png", alt: "SBT Marabá" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-24_4_1553279794.png", alt: "Difusora SBT MA" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-03_4_527538085.png", alt: "InterTV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-42_4_1752528081.png", alt: "LBV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-23_4_1574102900.png", alt: "Rede Família" },
              // duplicados para loop contínuo
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-05_4_1314648642.png", alt: "ND TV" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-sbt-rede-massa.png", alt: "Rede Massa SBT" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-aparecida.png", alt: "TV Aparecida" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-sictvrecord.png", alt: "SIC TV Record" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-anhanguera.png", alt: "TV Anhanguera" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-pajucara.png", alt: "TV Pajuçara" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-redetvrn.png", alt: "Rede TV RN" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-band.png", alt: "Grupo Bandeirantes" },
              { src: "https://painel.solidweb.com.br/uploads/113/tv-sbt-hdtv.png", alt: "SBT Santa Catarina" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-15_4_1264733846.png", alt: "Antena 10" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-55_4_1179154877.png", alt: "Band Natal" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-01_4_436039229.png", alt: "Band Piauí" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-32_4_1032820651.png", alt: "Band RJ Interior" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-40_4_89120446.png", alt: "Band Campinas" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-10_4_330940411.png", alt: "Band Sports" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-39_4_1788310047.png", alt: "SBT Marabá" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-24_4_1553279794.png", alt: "Difusora SBT MA" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-03_4_527538085.png", alt: "InterTV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-42_4_1752528081.png", alt: "LBV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-23_4_1574102900.png", alt: "Rede Família" },
            ].map((c, i) => (
              <div key={i} className="clients-logo-wrap" style={{
                flexShrink: 0,
                width: 130,
                height: 72,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: 10,
                padding: "0.75rem 1rem",
                transition: "background 0.3s, border-color 0.3s",
              }}>
                <img src={c.src} alt={c.alt} style={{ maxWidth: "100%", maxHeight: 44, objectFit: "contain" }} />
              </div>
            ))}
          </div>

          {/* Faixa 2 — direita (sentido inverso) */}
          <div className="clients-track-bwd" style={{ display: "flex", gap: "1rem", width: "max-content" }}>
            {[
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-43_4_1737769141.png", alt: "NSC TV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-13_4_943766896.png", alt: "Record GV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-48_4_151991722.png", alt: "Record Palmas" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-18_4_545198528.png", alt: "Record TV Goiás" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-01_4_1408635953.png", alt: "RS 21" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-35_4_1031142216.png", alt: "SBT Castanhal" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-11_4_836260471.png", alt: "SBT Goiás" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-14_4_1378089922.png", alt: "SBT Interior" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-45_4_1895620894.png", alt: "Terra Viva" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-18_4_1812075452.png", alt: "TV Capital" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-49_4_1698058849.png", alt: "TV Claret" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-21_4_12446971.png", alt: "TV Metropolitana" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-01_4_1544946822.png", alt: "TV Novo Tempo" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-53_4_502635540.png", alt: "TV Sucesso GO" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-35_4_1385271912.png", alt: "TV Tambaú PB" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-07_4_619845187.png", alt: "TV Vale do Xingu" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-55_4_2101362783.jpg", alt: "SBT" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-19_4_481159650.jpg", alt: "SBT RS" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-07_4_671400253.jpg", alt: "TV Integração Globo" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-28_4_1841725031.jpg", alt: "TV Integração JF" },
              // duplicados
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-43_4_1737769141.png", alt: "NSC TV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-13_4_943766896.png", alt: "Record GV" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-48_4_151991722.png", alt: "Record Palmas" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-18_4_545198528.png", alt: "Record TV Goiás" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-01_4_1408635953.png", alt: "RS 21" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-35_4_1031142216.png", alt: "SBT Castanhal" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-11_4_836260471.png", alt: "SBT Goiás" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-14_4_1378089922.png", alt: "SBT Interior" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-45_4_1895620894.png", alt: "Terra Viva" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-18_4_1812075452.png", alt: "TV Capital" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-49_4_1698058849.png", alt: "TV Claret" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-21_4_12446971.png", alt: "TV Metropolitana" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-01_4_1544946822.png", alt: "TV Novo Tempo" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-53_4_502635540.png", alt: "TV Sucesso GO" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-35_4_1385271912.png", alt: "TV Tambaú PB" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2020-08-19_15-08-07_4_619845187.png", alt: "TV Vale do Xingu" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-55_4_2101362783.jpg", alt: "SBT" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-19_4_481159650.jpg", alt: "SBT RS" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-07_4_671400253.jpg", alt: "TV Integração Globo" },
              { src: "https://painel.solidweb.com.br/uploads/113/113_2026-01-13_08-01-28_4_1841725031.jpg", alt: "TV Integração JF" },
            ].map((c, i) => (
              <div key={i} className="clients-logo-wrap" style={{
                flexShrink: 0,
                width: 130,
                height: 72,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "rgba(255,255,255,0.04)",
                border: "1px solid rgba(255,255,255,0.07)",
                borderRadius: 10,
                padding: "0.75rem 1rem",
                transition: "background 0.3s, border-color 0.3s",
              }}>
                <img src={c.src} alt={c.alt} style={{ maxWidth: "100%", maxHeight: 44, objectFit: "contain" }} />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA FINAL */}
      <section style={{
        padding: "6rem clamp(1.5rem, 8vw, 9rem) 7rem",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
      }}>
        {/* glow de fundo */}
        <div style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 700,
          height: 400,
          background: `radial-gradient(ellipse at center, ${ACCENT}22 0%, transparent 70%)`,
          pointerEvents: "none",
        }} />

        <span style={{
          display: "inline-block",
          fontSize: "0.7rem",
          fontWeight: 700,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          color: ACCENT,
          marginBottom: "1.25rem",
        }}>Comece agora</span>

        <h2 style={{
          fontSize: "clamp(2.2rem, 5vw, 4rem)",
          fontWeight: 700,
          letterSpacing: "-0.04em",
          lineHeight: 1.1,
          margin: "0 auto 1.25rem",
          maxWidth: 700,
          color: "#fff",
        }}>
          Sua transmissão ao vivo começa{" "}
          <span style={{ color: ACCENT }}>de graça</span>
        </h2>

        <p style={{
          fontSize: "clamp(0.95rem, 1.3vw, 1.1rem)",
          color: "rgba(255,255,255,0.4)",
          maxWidth: 480,
          margin: "0 auto 2.5rem",
          lineHeight: 1.7,
        }}>
          Crie sua conta em menos de 1 minuto. Sem cartão de crédito, sem compromisso — comece a engajar seu público hoje mesmo, seja na TV, no podcast ou no seu evento.
        </p>

        <div style={{ display: "flex", gap: "1rem", justifyContent: "center", flexWrap: "wrap", marginBottom: "1.25rem" }}>
          <RouterLink
            to="/account/register"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.5rem",
              background: ACCENT,
              color: "#000",
              fontWeight: 700,
              fontSize: "1rem",
              padding: "0.85rem 2.2rem",
              borderRadius: 9999,
              textDecoration: "none",
              letterSpacing: "-0.01em",
              boxShadow: `0 0 32px ${ACCENT}55`,
            }}
          >
            Criar conta grátis
          </RouterLink>
          <RouterLink
            to="/account/login"
            style={{
              display: "inline-flex",
              alignItems: "center",
              color: "rgba(255,255,255,0.55)",
              fontWeight: 500,
              fontSize: "1rem",
              padding: "0.85rem 2rem",
              borderRadius: 9999,
              textDecoration: "none",
              border: "1px solid rgba(255,255,255,0.12)",
              letterSpacing: "-0.01em",
            }}
          >
            Já tenho conta
          </RouterLink>
          <RouterLink
            to="/planos"
            style={{
              display: "inline-flex",
              alignItems: "center",
              color: "rgba(255,255,255,0.55)",
              fontWeight: 500,
              fontSize: "1rem",
              padding: "0.85rem 2rem",
              borderRadius: 9999,
              textDecoration: "none",
              border: "1px solid rgba(255,255,255,0.12)",
              letterSpacing: "-0.01em",
            }}
          >
            Ver planos
          </RouterLink>
        </div>

        <div style={{
          display: "flex",
          gap: "2rem",
          justifyContent: "center",
          flexWrap: "wrap",
        }}>
          {[
            "Plano gratuito",
            "Sem cartão de crédito",
            "Suporte incluído",
          ].map((item) => (
            <span key={item} style={{
              fontSize: "0.8rem",
              color: "rgba(255,255,255,0.3)",
              display: "flex",
              alignItems: "center",
              gap: "0.35rem",
            }}>
              <span style={{ color: ACCENT, fontSize: "0.75rem" }}>✓</span>
              {item}
            </span>
          ))}
        </div>
      </section>


      <LandingFooter />
    </div>
  );
}
